var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 3.942c-.824.366-1.65.641-2.567.734.916-.551 1.65-1.468 2.016-2.477-.917.551-1.834.916-2.84 1.102-.917-.916-2.109-1.468-3.39-1.468a4.498 4.498 0 00-4.495 4.49c0 .37 0 .735.093 1.01-3.76-.182-7.057-1.926-9.26-4.676C1.1 3.3.918 4.125.918 4.949c0 1.56.823 2.936 2.016 3.76-.734-.094-1.465-.276-2.016-.552v.093c0 2.199 1.557 4.032 3.573 4.4-.365.09-.73.183-1.189.183-.275 0-.551 0-.827-.093.552 1.834 2.202 3.12 4.218 3.12-1.557 1.191-3.484 1.922-5.593 1.922-.365 0-.734 0-1.099-.09a12.843 12.843 0 006.875 2.016c8.343 0 12.833-6.875 12.833-12.833v-.551c.917-.641 1.651-1.465 2.292-2.382z",
    fill: "#47A0EB"
  })));
}

export default SvgTwitterIcon;